import * as React from "react";
const SvgFiBrandsAero = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-aero_svg__a)">
      <path d="m8.933 8.144 1.272 4.17H7.66z" />
      <path d="M19.75.3H4.25A4.25 4.25 0 0 0 0 4.55v14.9a4.25 4.25 0 0 0 4.25 4.25h15.5A4.25 4.25 0 0 0 24 19.45V4.55A4.25 4.25 0 0 0 19.75.3m-5.874 16.5h-2.093a.15.15 0 0 1-.161-.113l-.821-2.387H7.082l-.757 2.355a.19.19 0 0 1-.193.145H4.248q-.16 0-.113-.177l3.22-9.235c.033-.097.065-.191.097-.315q.063-.323.065-.652a.1.1 0 0 1 .112-.113h2.56q.113 0 .129.08l3.655 10.25q.048.162-.097.162m5.916-7.98v1.949q0 .113-.161.113a3.6 3.6 0 0 0-.997.072 4 4 0 0 0-.837.266c-.231.107-.476.23-.604.37v5.065q0 .145-.129.145H15.18a.142.142 0 0 1-.161-.16v-5.5a40 40 0 0 0-.032-1.53 6 6 0 0 0-.064-.697.093.093 0 0 1 .113-.113h1.755a.22.22 0 0 1 .209.16q.057.128.081.263.034.156.048.314.016.169.016.362a3.8 3.8 0 0 1 1.071-.862 2.8 2.8 0 0 1 1.432-.362c.07-.01.135.038.145.108z" />
    </g>
    <defs>
      <clipPath id="fi-brands-aero_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsAero;
